let eventBuffer = [];
let config = {};

export function getBufferedEvents() {
  return [...eventBuffer]; // read-only copy
}

export function clearBufferedEvents() {
  eventBuffer = [];
}

// ---- Event Trackers ----
function trackClick(e) {
  eventBuffer.push({
    type: "click",
    x: e.clientX,
    y: e.clientY,
    tag: e.target.tagName,
    id: e.target.id,
    class: e.target.className,
    timestamp: Date.now(),
  });
}

function trackScroll() {
  eventBuffer.push({
    type: "scroll",
    scrollY: window.scrollY,
    timestamp: Date.now(),
  });
}

function trackInput(e) {
  eventBuffer.push({
    type: "input",
    tag: e.target.tagName,
    name: e.target.name || "",
    value: e.target.value || "",
    timestamp: Date.now(),
  });
}

function trackMouseMove(e) {
  eventBuffer.push({
    type: "mousemove",
    x: e.clientX,
    y: e.clientY,
    timestamp: Date.now(),
  });
}

function trackKeyDown(e) {
  eventBuffer.push({
    type: "keydown",
    key: e.key,
    code: e.code,
    target: e.target.tagName,
    timestamp: Date.now(),
  });
}

function trackFocus(e) {
  eventBuffer.push({
    type: "focus",
    tag: e.target.tagName,
    id: e.target.id,
    timestamp: Date.now(),
  });
}

function trackBlur(e) {
  eventBuffer.push({
    type: "blur",
    tag: e.target.tagName,
    id: e.target.id,
    timestamp: Date.now(),
  });
}

// ---- Start Tracking ----
export function startTracking(userConfig) {
  config = userConfig;

  if (config.events.includes("click")) {
    window.addEventListener("click", trackClick);
  }

  if (config.events.includes("scroll")) {
    window.addEventListener("scroll", trackScroll);
  }

  if (config.events.includes("input")) {
    document.addEventListener("input", trackInput);
  }

  if (config.events.includes("mousemove")) {
    window.addEventListener("mousemove", trackMouseMove);
  }

  if (config.events.includes("keydown")) {
    window.addEventListener("keydown", trackKeyDown);
  }

  if (config.events.includes("focus")) {
    window.addEventListener("focus", trackFocus, true); // useCapture = true to catch on all inputs
  }

  if (config.events.includes("blur")) {
    window.addEventListener("blur", trackBlur, true);
  }

  window.addEventListener("beforeunload", () => {
    if (config.onFlush && typeof config.onFlush === "function") {
      config.onFlush(getBufferedEvents());
    }
  });

  setInterval(() => {
    if (config.onFlush && typeof config.onFlush === "function") {
      config.onFlush(getBufferedEvents());
      clearBufferedEvents();
    }
  }, config.flushInterval || 5000);
}
